export default __webpack_public_path__ + "static/react-809fed23bcdd686de66e68e1af3de772.png";